module.exports = __webpack_public_path__ + "media/images/service/s_2-d16649cc31348d4b1c8bd6483ac797e4.png";